// utils/styles.js

/**
 * combine - fusionne plusieurs objets de styles (incluant media-queries) en concaténant
 * leurs valeurs de propriétés CSS.
 *
 * Exemple :
 * const combined = combine(padding.s, padding.m);
 * // Résultat pour '@media only screen and (max-width:1920px)': { padding: '10px 15px' }
 */
export function combine(...styleObjects) {
  // Si aucun ou un seul objet passé, on retourne directement son contenu ou un objet vide
  if (styleObjects.length <= 1) {
    return styleObjects[0] || {};
  }

  const result = {};
  // Collecte toutes les clés (media queries ou defaults)
  const keys = new Set();
  styleObjects.forEach(obj => {
    Object.keys(obj).forEach(k => keys.add(k));
  });

  // Pour chaque clé, fusionne les propriétés
  keys.forEach(key => {
    const mergedProps = {};
    styleObjects.forEach(obj => {
      const rules = obj[key];
      if (!rules) return;
      Object.entries(rules).forEach(([prop, val]) => {
        // Supprime les guillemets éventuels autour de la valeur
        const stripped = String(val).replace(/^['"]|['"]$/g, '');
        if (mergedProps[prop]) {
          // Concatène les valeurs avec un espace
          mergedProps[prop] = `${mergedProps[prop]} ${stripped}`;
        } else {
          mergedProps[prop] = stripped;
        }
      });
    });

    // Assigne la valeur fusionnée
    result[key] = {};
    Object.entries(mergedProps).forEach(([prop, mergedVal]) => {
      result[key][prop] = mergedVal;
    });
  });
  return result;
}
